import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import React from 'react';
import { Form } from 'src/components/Antd';
import { OrderAmount } from 'src/constrains/AdvancedFilters/Components';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Filters/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { Clear } from '../Components';
const Item = Form.Item;

const NumberOfOrders = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    root,
    form,
    state,
    nameType,
    nameValue,
    nameRange,
    selectName,
    disabled,
    ...rest
  } = props;
  return (
    <SectionWrapper title={getI18n('customerTag.orderDate.numberoforders')}>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper title=''>
                <OrderAmount
                  nameValue={nameValue}
                  nameRange={nameRange}
                  nameType={nameType}
                  selectName={selectName}
                  disabled={disabled}
                  {...rest}
                />
                <Item
                  shouldUpdate={(p, c) => {
                    const touched = form.isFieldTouched(root);
                    return touched; //|| cv !== pv;
                  }}>
                  {(f) => {
                    const { getFieldValue } = f;

                    const hasValue = getFieldValue(selectName);

                    if (hasValue) {
                      return (
                        <Clear
                          disabled={disabled}
                          onClick={() => {
                            form.setFieldsValue(state);
                          }}
                        />
                      );
                    }
                  }}
                </Item>
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
    </SectionWrapper>
  );
};
export default NumberOfOrders;
